import Header from "../components/Header";
import Footer from "../components/Footer";
import BreakingTicker from "../components/BreakingTicker";

export default function PublicLayout({ children }) {
  return (
    <div className="App">
      <BreakingTicker />
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
